module.exports = __webpack_public_path__ + "img/banner.ed777022.jpg";